module.exports = __webpack_public_path__ + "img/rukavy_08_zluta.c27360a4.png";